const CptName = 'ComImg'
let is_prelaod = false

function formatData (node, article, store) {
  store = initImgStore(store)
  if (is_prelaod != article.options.preload) {
    is_prelaod = article.options.preload
    store.img_store.all_img_urls = []
    store.img_store.index = 0
  }
  // 设置懒加载回调
  let resolve, promise = new Promise(r => (resolve = r))
  store.img_store.all_img_urls.push(node.dataset.original)
  return {
    data: {
      url: node.dataset.original,
      urls: store.img_store.all_img_urls,
      index: store.img_store.index++,
      next: [promise, resolve],
      width: node.dataset.width,
      height: node.dataset.height,
      imgs_list: store.img_store.imgs_list
    },
    cpt: CptName
  }
}

function initImgStore (store) {
  if (store.img_store) {
    return store
  } 
  store.img_store = {
    all_img_urls: [],
    imgs_list: [],
    index: 0
  }
  return store
}

export default {
  name: 'img',
  formatData
}
